var map = {
	"./75-years.png": 964,
	"./Reynolds_logo.svg": 136,
	"./Reynolds_logo_inverse.svg": 836,
	"./bg-blue.png": 520,
	"./bg-footer.png": 814,
	"./chedraui.png": 345,
	"./heb.png": 37,
	"./image-kitchen.png": 834,
	"./image_top.png": 687,
	"./lacomer.png": 647,
	"./reynolds-bolsas.png": 819,
	"./reynolds-papel-aluminio.png": 544,
	"./reynolds-papel-hornear.png": 625,
	"./reynolds-plastico-adherente.png": 160,
	"./soriana.png": 110,
	"./walmart.png": 183
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;